import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "./firebase";
import { useRuolo } from "./useRuolo";

function ProtectedRoute({ children, ruoliConsentiti = [] }) {
  const [user, userLoading] = useAuthState(auth);
  const { ruolo, loading: ruoloLoading } = useRuolo(user?.uid);
  const navigate = useNavigate();
  const [accessoNegato, setAccessoNegato] = useState(false);

  const accessoConsentito =
    ruolo && (ruoliConsentiti.includes(ruolo) || ruolo === "admin");

  useEffect(() => {
    if (
      !userLoading &&
      !ruoloLoading &&
      user &&
      ruolo &&
      !accessoConsentito
    ) {
      setAccessoNegato(true);
      const destinazione =
        ruolo === "admin" ? "/dashboard-gestore" : "/";

      setTimeout(() => {
        navigate(destinazione);
      }, 3000);
    }
  }, [userLoading, ruoloLoading, user, ruolo, accessoConsentito, navigate]);

  if (userLoading || ruoloLoading || !ruolo) {
    return <p>🔄 Caricamento...</p>;
  }

  if (!user) return <Navigate to="/login" />;

  if (accessoNegato) {
    const ruoliTesto = ruoliConsentiti.length > 0
      ? ruoliConsentiti.join(", ")
      : "nessuno";

    return (
      <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <h2>🚫 Accesso non autorizzato</h2>
        <p>
          Questa pagina è riservata agli utenti con ruolo:{" "}
          <strong>{ruoliTesto}</strong>.
        </p>
        <p>
          Stai accedendo come <strong>{ruolo || "sconosciuto"}</strong>.
        </p>
        <p>🔁 Verrai reindirizzato tra pochi secondi…</p>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
